// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import * as tslib_1 from "tslib";
// THIS FILE WAS AUTOGENERATED
import { Base } from './Base';
/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    tslib_1.__extends(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(Base));
export { Data };
//# sourceMappingURL=Data.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/Generated/Data.js
// module id = 225
// module chunks = 42